import axios from "axios";

const BACKEND_URL = window.location.origin;
export const COTACAO_API = `${BACKEND_URL}/api`;

// Instância axios exclusiva do produto Cotações — usa o token de cotacao,
// não o do Compromisso Digital, para evitar cross-contamination.
export const cotAxios = axios.create({ baseURL: COTACAO_API });

cotAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("cotacao_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

cotAxios.interceptors.response.use(
  (r) => r,
  (err) => {
    // Se token expirou/inválido, redireciona para login do produto Cotações
    if (err?.response?.status === 401) {
      const msg = err?.response?.data?.detail || "";
      if (/token|usu[aá]rio/i.test(String(msg))) {
        localStorage.removeItem("cotacao_token");
        localStorage.removeItem("cotacao_user");
        if (!window.location.pathname.startsWith("/cotacoes/login")) {
          window.location.href = "/cotacoes/login";
        }
      }
    }
    return Promise.reject(err);
  }
);
